/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const Slice = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 5000;
`;

export const Container = styled.div`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  display: flex;
  flex-direction: column;
`;

export const SelectHeader = styled.input``;

export const Ul = styled.ul`
  max-height: 258px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 5px;
  border-radius: 8px;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${() => Palette.PrimaryGray._300};
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }
`;
export const InputHeader = styled.div``;

export const InputContainer = styled.div``;

export const RadioBtn = styled.button`
  cursor: pointer;
  background-color: inherit;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid ${Palette.PrimaryGray._400};
  border: ${({ isActive }) => isActive && `6px solid ${Palette.Primary._500}`};
`;
export const ComponentForScroll = styled.div`
  z-index: 6000;
  background: white;
  max-height: 270px;
  padding-top: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  box-shadow: 0px 16px 24px rgba(23, 43, 77, 0.04), 0px 16px 32px rgba(23, 43, 77, 0.08);
  border-radius: 8px;
  border: 1px solid ${Palette.PrimaryGray._200};
`;
export const Li = styled.li`
  z-index: 6000;
  display: flex;
  align-items: center;
  gap: 16px;
  list-style: none;
  margin-right: 5px;
  color: ${({ isActive }) => isActive && `${Palette.Primary._500}`};
  cursor: pointer;
  &:hover {
    border-radius: 4px;
    background: ${() => Palette.PrimaryGray._100};
    ${RadioBtn} {
      border: 6px solid ${Palette.Primary._500};
    }
  }
  &:active {
    border-radius: 4px;
    background: ${() => Palette.Primary._000};
  }

  padding: 7px 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
